const HP_KW_CONVERSION_FACTOR = 1.35962;

export const kwToHp = (kw: number): number => {
  return Math.round(kw * HP_KW_CONVERSION_FACTOR);
};

export const hpToKw = (hp: number): number => {
  return Math.round(hp / HP_KW_CONVERSION_FACTOR);
};
